export default {
  changeSegments(state, data) {
    state.segments = data
  },
  changeSegmentParams(state, value) {
    state.segmentsParams = value
  },
  changeSelectedSegmentForSend(state, value) {
    state.selectedSegmentForSend = value
  },
  changeClientsInSelectedSegment(state, value) {
    state.clientsInSelectedSegment = value
  },
  changeNewSegmentForm(state, { key, value }) {
    state.newSegmentForm[key] = value
  },
  changeCreateSegmentModalIsActive(state, value) {
    state.createSegmentModalIsActive = value
  },
}
